<template>
  <div class="container py-4">
    <div class="mb-5">
      <PrimaryTitle class="font-weight-bold">Lives exclusivas</PrimaryTitle>
      <div>Assista onde e quando quiser as lives exclusivas com especialistas no assunto</div>
    </div>

    <section
      class="list"
      v-infinite-scroll="fetchResources"
    >
      <div class="row">
        <div
          v-for="live in lives"
          :key="live.id"
          class="col-lg-4 col-xs-12 mb-4"
        >
          <LiveItem :live="live" />
        </div>
      </div>

      <LoadingIcon v-if="isLoading" />
    </section>
  </div>
</template>

<script>
import { computed, onBeforeMount, ref } from '@vue/composition-api'
import { fetchPremiumLives } from '@/api/live.api'
import PrimaryTitle from '@/components/text/titles/PrimaryTitle'
import LiveItem from '@/components/live/LiveItem'
import vInfiniteScroll from 'vue-infinite-scroll'
import LoadingIcon from '@/components/layout/LoadingIcon'
import store from '@/store'
import router from '@/router'

export default {
  components: {
    PrimaryTitle,
    LiveItem,
    LoadingIcon
  },
  directives: {
    infiniteScroll: vInfiniteScroll
  },
  setup() {
    const livesPage = ref(1)
    const lives = ref([])
    const isLoading = ref(false)
    const isLastPage = ref(false)

    const hasAccess = computed(() => store.getters['user/hasUserSubscriptionAccess'])

    async function fetchResources () {
      if (isLoading.value || isLastPage.value || !hasAccess.value) return
      
      isLoading.value = true
      
      const { data, next_page_url: nextPageUrl } = await fetchPremiumLives({ page: livesPage.value++ })

      data.forEach(live => lives.value.push(live))

      isLastPage.value = nextPageUrl === null

      isLoading.value = false
    }

    onBeforeMount(() => {
      if (!hasAccess.value) {
        router.replace('/')
      }
    })

    return {
      lives,
      isLoading,
      fetchResources
    }
  }
}
</script>